import { ReactNode, useState } from "react";

interface TabItem {
  value: string;
  label: string;
  content: ReactNode;
}

interface TabsProps {
  tabs: TabItem[];
  activeTab?: string;
  onTabChange?: (value: string) => void;
  activeTextClass?: string;
  activeBorderClass?: string;
  activeGlowClass?: string;
}

export default function Tabs({
  tabs,
  activeTab,
  onTabChange,
  activeTextClass = "text-blue-600",
  activeBorderClass = "border-blue-600",
  activeGlowClass = "bg-blue-500/40",
}: TabsProps) {
  const [internalActive, setInternalActive] = useState(tabs[0]?.value || "");

  const active = activeTab !== undefined ? activeTab : internalActive;

  const handleTabClick = (value: string) => {
    if (onTabChange) {
      onTabChange(value);
    } else {
      setInternalActive(value);
    }
  };

  return (
    <div>
      {/* TABS */}
      <div
        className="
          flex border-b border-gray-300 dark:border-gray-700
          overflow-x-auto no-scrollbar
          gap-4 sm:gap-6 
          mt-10
          justify-start sm:justify-center
        "
      >
        {tabs.map((tab) => {
          const isActive = active === tab.value;

          return (
            <button
              key={tab.value}
              onClick={() => handleTabClick(tab.value)}
              className={`
                relative px-3 py-2 text-sm font-medium transition-all whitespace-nowrap
                border-b-2
                ${isActive
                  ? `${activeTextClass} ${activeBorderClass}`
                  : "text-gray-600 dark:text-gray-300 border-transparent"
                }
              `}
            >
              {tab.label}

              {isActive && (
                <span
                  className={`
                    absolute left-0 right-0 -bottom-[6px] h-[4px]
                    ${activeGlowClass}
                    blur-md rounded
                  `}
                />
              )}
            </button>
          );
        })}
      </div>

      {/* CONTENIDO */}
      <div className="mt-10 w-full">
        {tabs.map((tab) =>
          active === tab.value ? (
            <div key={tab.value}>{tab.content}</div>
          ) : null
        )}
      </div>
    </div>
  );
}
